module.exports = __webpack_public_path__ + "img/obs.9c2c90db.png";